export default __webpack_public_path__ + "static/media/Podcast_People.2cd0aff9.png";